(function () {
  if (window.__numiAddToCartInit) return;
  window.__numiAddToCartInit = true;

  function showToast(html, isError) {
    var existing = document.querySelector('.numi-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'numi-toast' + (isError ? ' is-error' : '');
    toast.innerHTML = html;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, 3500);
  }

  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return false;
        var newDoc = new DOMParser().parseFromString(html, 'text/html');
        var newCartDrawer = newDoc.querySelector('cart-drawer');
        var existingCartDrawer = document.querySelector('cart-drawer');
        if (newCartDrawer && existingCartDrawer) {
          var wasOpen = existingCartDrawer.classList.contains('active') || existingCartDrawer.classList.contains('is-open') || document.body.classList.contains('cart-drawer-open');
          existingCartDrawer.outerHTML = newCartDrawer.outerHTML;
          if (wasOpen) openCartDrawer();
          return true;
        }
        return false;
      })
      .catch(function () { return false; });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') { try { drawer.open(); return true; } catch (e) {} }
    drawer.classList.add('active', 'is-open', 'animate');
    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    return true;
  }

  function handleSubmit(form, e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('button, [type=submit]');
    if (btn && btn.disabled) return;

    var rawId = form.dataset.variantId || ((form.querySelector('input[name=id]') || {}).value || '');
    var variantId = parseInt(rawId, 10);
    var planName = form.dataset.planName || 'Shedless';
    var labelEl = btn ? (btn.querySelector('.numi-cta-label') || btn) : null;
    var originalLabel = labelEl ? labelEl.textContent.trim() : '';

    if (!variantId || isNaN(variantId)) {
      showToast('<span>Missing variant ID</span>', true);
      return;
    }

    if (btn) btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding…';

    var planEl = form.querySelector('input[name=selling_plan]');
    var planId = planEl && !planEl.disabled ? (planEl.value || '').trim() : '';

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    if (planId) formData.append('selling_plan', planId);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.text().then(function (text) {
          var data;
          try { data = JSON.parse(text); } catch (err) { data = { raw: text }; }
          return { status: r.status, ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || ('HTTP ' + res.status);
          throw new Error(msg);
        }
        /* Pre-add shipping protection BEFORE the first cart-drawer refresh.
           Old flow: refresh drawer (no protection) -> open -> renderEnhancements
           adds protection -> refresh drawer again = visible flash.
           New flow: add main item -> add protection inline -> refresh drawer once
           with both items already present -> open = no flash. */
        return ensureProtectionAdded().then(function () {
          return refreshCartDrawer();
        }).then(function () {
          /* renderCartEnhancements still runs to attach the toggle UI, but
             reconcileProtection inside it will see protection already in cart
             and skip the add -> no second refresh, no flash. */
          setTimeout(renderCartEnhancements, 50);
          return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble, .header__cart-count, .js-cart-count').forEach(function (el) {
                if (el.tagName !== 'CART-DRAWER' && el.children.length === 0) el.textContent = cart.item_count;
              });
              if (labelEl) labelEl.textContent = '✓ Added';
              showToast('<span class="numi-toast-check">✓</span><span>' + planName + ' added to cart</span>');
              setTimeout(openCartDrawer, 100);
              setTimeout(function () {
                if (labelEl) labelEl.textContent = originalLabel;
                if (btn) btn.disabled = false;
              }, 1800);
            });
        });
      })
      .catch(function (err) {
        if (labelEl) labelEl.textContent = 'Try again';
        showToast('<span>Could not add — ' + (err.message || 'try again') + '</span>', true);
        setTimeout(function () {
          if (labelEl) labelEl.textContent = originalLabel;
          if (btn) btn.disabled = false;
        }, 2000);
      });
  }

  // === Cart enhancements: sub nudge, trust strip, GLP-1 reassurance ===
  var SELLING_PLAN_MAP = {
    '61838421623154': '694226911602',
    '61851982594418': '694237593970',
    '61851982627186': '694237626738'
  };

  function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }

  // === Shipping Protection (always-on add-on) ===
  var SHIP_PROTECTION = { variantId: 62370683027826, price: '$2.95', optOutKey: 'numi_sp_optout' };
  // Treat every page load as fresh — wipe any session-level opt-out memory
  // and reset the failure flag so a one-off network error doesn't permanently
  // disable auto-add. The customer can still toggle off in the current view,
  // but a reload re-enables protection. Matches user request: "auto enable".
  try { sessionStorage.removeItem(SHIP_PROTECTION.optOutKey); } catch (e) {}
  window.__numiSPFailed = false;
  function spOptedOut() { try { return sessionStorage.getItem(SHIP_PROTECTION.optOutKey) === '1'; } catch (e) { return false; } }
  function spSetOptOut(v) { try { if (v) sessionStorage.setItem(SHIP_PROTECTION.optOutKey, '1'); else sessionStorage.removeItem(SHIP_PROTECTION.optOutKey); } catch (e) {} }
  function spProtItem(cart) { return (cart.items || []).filter(function (it) { return it.variant_id === SHIP_PROTECTION.variantId; })[0]; }
  function spRealItems(cart) { return (cart.items || []).filter(function (it) { return it.variant_id !== SHIP_PROTECTION.variantId; }); }
  function spNeedsChange(cart) {
    if (window.__numiSPFailed) return false;
    var prot = spProtItem(cart), real = spRealItems(cart);
    if (real.length === 0) return !!prot;
    if (!prot && !spOptedOut()) return true;
    if (prot && prot.quantity > 1) return true;
    return false;
  }
  function spChange(qty) {
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(SHIP_PROTECTION.variantId), quantity: qty }) });
  }
  function spAdd() {
    var fd = new FormData(); fd.append('id', String(SHIP_PROTECTION.variantId)); fd.append('quantity', '1');
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
  }
  /* Synchronous inline check used by handleSubmit: fetches the current cart,
     adds shipping protection if it's missing and the customer hasn't toggled
     it off in this view, returns a promise that resolves once the cart is in
     its final state. Used to merge two cart-drawer renders into one and kill
     the post-ATC flash. */
  function ensureProtectionAdded() {
    if (window.__numiSPBusy || window.__numiSPFailed) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prot = spProtItem(cart);
        var real = spRealItems(cart);
        if (real.length === 0) return;            /* nothing to protect */
        if (prot) return;                          /* already there */
        if (spOptedOut()) return;                  /* customer opted out this view */
        window.__numiSPBusy = true;
        return spAdd().then(function (r) {
          if (!r.ok) window.__numiSPFailed = true;
        }).catch(function () {
          window.__numiSPFailed = true;
        }).then(function () {
          window.__numiSPBusy = false;
        });
      })
      .catch(function () { /* never block ATC on a protection-fetch failure */ });
  }

  function reconcileProtection(cart) {
    if (window.__numiSPBusy) return Promise.resolve(false);
    var prot = spProtItem(cart), real = spRealItems(cart), op = null, isAdd = false;
    if (real.length === 0 && prot) op = spChange(0);
    else if (real.length > 0 && !prot && !spOptedOut() && !window.__numiSPFailed) { op = spAdd(); isAdd = true; }
    else if (prot && prot.quantity > 1) op = spChange(1);
    if (!op) return Promise.resolve(false);
    window.__numiSPBusy = true;
    return op.then(function (r) { if (isAdd && r && !r.ok) throw 0; return true; })
      .catch(function () { if (isAdd) window.__numiSPFailed = true; return false; })
      .then(function (c) { window.__numiSPBusy = false; return c; });
  }
  function spIcon() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>'; }
  function spPatchDisplays() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var live = document.querySelector('cart-drawer');
        if (!live) return false;
        window.__numiSuppressObserver = true;
        // Totals: copy money values via text node only
        var nT = doc.querySelectorAll('.cart-drawer__totals__row__money');
        var lT = live.querySelectorAll('.cart-drawer__totals__row__money');
        for (var i = 0; i < lT.length && i < nT.length; i++) { if (lT[i].textContent !== nT[i].textContent) lT[i].textContent = nT[i].textContent; }
        // Progress: update only the amount text node + bar width (no element add/remove)
        var nP = doc.querySelector('.cart-progress'), lP = live.querySelector('.cart-progress');
        if (nP && lP) {
          var nSpan = nP.querySelector('.cart-progress__text span'), lSpan = lP.querySelector('.cart-progress__text span');
          if (nSpan && lSpan) { if (lSpan.textContent !== nSpan.textContent) lSpan.textContent = nSpan.textContent; }
          else {
            var nTxt = nP.querySelector('.cart-progress__text'), lTxt = lP.querySelector('.cart-progress__text');
            if (nTxt && lTxt && lTxt.innerHTML !== nTxt.innerHTML) lTxt.innerHTML = nTxt.innerHTML;
          }
          var nBar = nP.querySelector('.cart-progress__bar__progress'), lBar = lP.querySelector('.cart-progress__bar__progress');
          if (nBar && lBar) lBar.style.width = nBar.style.width;
        }
        setTimeout(function () { window.__numiSuppressObserver = false; }, 150);
        return true;
      })
      .catch(function () { window.__numiSuppressObserver = false; return false; });
  }

  function renderProtectionRow(cart, drawer, forceOn) {
    if (!drawer) return;
    if (spRealItems(cart).length === 0) return;
    var on = !!spProtItem(cart) || !!forceOn;
    var anchor = drawer.querySelector('.cart-drawer__totals, .totals, .cart__totals') || drawer.querySelector('button[name="checkout"], .cart__checkout-button');
    if (!anchor || !anchor.parentNode) return;
    var row = document.createElement('div');
    row.className = 'numi-sp';
    row.innerHTML =
      '<span class="numi-sp__icon">' + spIcon() + '</span>' +
      '<span class="numi-sp__body"><span class="numi-sp__head">Shipping Protection</span>' +
      '<span class="numi-sp__sub">Covers lost, damaged or stolen orders</span></span>' +
      '<span class="numi-sp__price">' + SHIP_PROTECTION.price + '</span>' +
      '<button type="button" class="numi-sp__switch" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" aria-label="Toggle Shipping Protection"><span class="numi-sp__knob"></span></button>';
    anchor.parentNode.insertBefore(row, anchor);
    var sw = row.querySelector('.numi-sp__switch');
    sw.addEventListener('click', function () {
      if (window.__numiSPBusy) return;
      var isOn = sw.getAttribute('aria-checked') === 'true';
      window.__numiSPBusy = true;
      sw.setAttribute('aria-checked', isOn ? 'false' : 'true');
      var p;
      if (isOn) { spSetOptOut(true); p = spChange(0); }
      else { spSetOptOut(false); window.__numiSPFailed = false; p = spAdd(); }
      p.then(function () { return spPatchDisplays(); })
        .then(function () { window.__numiSPBusy = false; })
        .catch(function () { window.__numiSPBusy = false; sw.setAttribute('aria-checked', isOn ? 'true' : 'false'); });
    });
  }

  function renderCartEnhancements() {
    var drawer = document.querySelector('#CartDrawer, .cart-drawer');
    if (!drawer) return;
    // Wipe prior enhancements before re-render
    drawer.querySelectorAll('.numi-sub-nudge, .numi-cart-trust, .numi-cart-glp1, .numi-sp').forEach(function (el) { el.remove(); });

    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) return;

        // Shipping Protection: auto-add/remove in background, render toggle row
        var _spPending = (!window.__numiSPBusy && !window.__numiSPFailed && spRealItems(cart).length > 0 && !spProtItem(cart) && !spOptedOut());
        if (!window.__numiSPBusy && spNeedsChange(cart)) {
          reconcileProtection(cart).then(function (changed) { if (changed) refreshCartDrawer().then(function () { setTimeout(renderCartEnhancements, 60); }); });
        }
        renderProtectionRow(cart, drawer, _spPending);

        // Find anchor elements
        var totals = drawer.querySelector('.cart-drawer__totals, .totals, .cart__totals');
        var checkoutBtn = drawer.querySelector('button[name="checkout"], .cart__checkout-button');

        // Build subscribe nudge for any one-time item that has a plan available
        var oneTimeItems = (cart.items || []).filter(function (it) {
          return !it.selling_plan_allocation && SELLING_PLAN_MAP[String(it.variant_id)];
        });
        if (oneTimeItems.length && totals) {
          var item = oneTimeItems[0];
          var planId = SELLING_PLAN_MAP[String(item.variant_id)];
          var nudge = document.createElement('div');
          nudge.className = 'numi-sub-nudge';
          nudge.innerHTML =
            '<div class="numi-sub-nudge__icon">↻</div>' +
            '<div class="numi-sub-nudge__body">' +
              '<div class="numi-sub-nudge__head">Save 10% — subscribe & save</div>' +
              '<div class="numi-sub-nudge__sub">Get delivered automatically. Skip, pause, or cancel anytime.</div>' +
            '</div>' +
            '<button type="button" class="numi-sub-nudge__btn" data-line-key="' + escAttr(item.key) + '" data-plan-id="' + escAttr(planId) + '">Switch</button>';
          totals.parentNode.insertBefore(nudge, totals);
        }

        // Trust strip + GLP-1 line right above the checkout button
        if (checkoutBtn) {
          var trust = document.createElement('div');
          trust.className = 'numi-cart-trust';
          trust.innerHTML =
            '<span class="numi-cart-trust__item">Free shipping over $100</span>' +
            '<span class="numi-cart-trust__item">60-day guarantee</span>' +
            '<span class="numi-cart-trust__item">Cancel anytime</span>';

          var glp1 = document.createElement('div');
          glp1.className = 'numi-cart-glp1';
          glp1.textContent = 'Made for women on GLP-1 medications · Drug-free, hormone-free';

          checkoutBtn.parentNode.insertBefore(trust, checkoutBtn);
          checkoutBtn.parentNode.insertBefore(glp1, checkoutBtn);
        }

        // Wire the switch button
        drawer.querySelectorAll('.numi-sub-nudge__btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var lineKey = btn.dataset.lineKey;
            var planId = btn.dataset.planId;
            if (!lineKey || !planId) return;
            btn.disabled = true;
            var origLabel = btn.textContent;
            btn.textContent = 'Switching…';
            var drawerEl = document.querySelector('cart-drawer, .cart-drawer');
            if (drawerEl) drawerEl.classList.add('is-numi-loading');
            fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: lineKey, selling_plan: planId, quantity: undefined })
            })
              .then(function (r) { return r.json(); })
              .then(function () {
                return refreshCartDrawer();
              })
              .then(function () {
                openCartDrawer();
                setTimeout(function () {
                  renderCartEnhancements();
                  var freshDrawer = document.querySelector('cart-drawer, .cart-drawer');
                  if (freshDrawer) freshDrawer.classList.remove('is-numi-loading');
                  // Pop the updated price/subtotal to highlight the change
                  freshDrawer && freshDrawer.querySelectorAll('.cart-drawer__totals__row__money, .cart-drawer-item__price .price-item, .price__regular .price-item').forEach(function (el) {
                    el.classList.remove('numi-price-pop');
                    void el.offsetWidth; // reflow to restart animation
                    el.classList.add('numi-price-pop');
                  });
                  showToast('<span class="numi-toast-check">✓</span><span>Switched to subscription · save 10%</span>');
                }, 60);
              })
              .catch(function () {
                btn.disabled = false;
                btn.textContent = origLabel;
                if (drawerEl) drawerEl.classList.remove('is-numi-loading');
              });
          });
        });
      });
  }

  // Observe drawer re-renders and re-inject enhancements.
  // Watches document.body (stable) so we survive outerHTML replacements of <cart-drawer>.
  function observeCartDrawer() {
    if (!document.body) return;
    var debounce;
    var observer = new MutationObserver(function (mutations) {
      if (window.__numiSuppressObserver) return;
      var significant = mutations.some(function (m) {
        // Only react to mutations inside the cart drawer
        if (!m.target || !m.target.closest || !m.target.closest('cart-drawer, #CartDrawer, .cart-drawer')) return false;

        // Ignore the countdown timer ticking
        if (m.target.closest('.cart-timer')) return false;

        var added = Array.prototype.slice.call(m.addedNodes || []);
        var removed = Array.prototype.slice.call(m.removedNodes || []);
        var nodes = added.concat(removed);

        // Skip our own injections/removals
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.classList && (n.classList.contains('numi-sub-nudge') || n.classList.contains('numi-cart-trust') || n.classList.contains('numi-cart-glp1') || n.classList.contains('numi-sp'))) {
            return false;
          }
        }

        // Only react to element-level changes
        return nodes.some(function (n) { return n.nodeType === 1; });
      });
      if (!significant) return;
      clearTimeout(debounce);
      debounce = setTimeout(renderCartEnhancements, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function attach() {
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('.numi-add-form');
      if (!form) return;
      handleSubmit(form, e);
    }, true);
    observeCartDrawer();
    renderCartEnhancements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
